import React from 'react';
import PostedVideosSelect from './PostedVideosSelect';
import LyricUsesSelect from './LyricUsesSelect';

const BasicForm = ({ postedVideosChoices, lyricUsesChoices }) => {
  return (
    <>
      <h3 className='text-center mt-25 mb-25'>Annual Basic License</h3>
      <div className="form-group">
        <div className="row d-md-flex">
          <div className="col-md-6 pr-md-5">
            <PostedVideosSelect postedVideosChoices={postedVideosChoices} />
            <div className='px-5'><i className='text-small'><i className="fas fa-info-circle mr-5"></i>A "posted video" is defined as any unique prerecorded or streamed performance / event that is posted online.</i></div>
          </div>
          <div className="col-md-6 pl-md-5">
            <LyricUsesSelect lyricUsesChoices={lyricUsesChoices} />
            <div className='px-5'><i className='text-small'><i className="fas fa-info-circle mr-5"></i>A "lyric use" is defined as any display of a song lyric included in a concert program, stream, projection screen, etc.</i></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicForm;
